import { type JSX } from 'react';

import { Picture, QuickBetsIcon } from '@cx-modules/ui';

import { useOddsGridContext } from '../../context/OddsGridContext';
import { useBookmakerData } from '../../hooks/useBookmakerData';
import { useSelector } from '../../providers/StoreProvider';
import { BookmakerClickOut } from '../BookmakerClickOut';
import { quickBetIcon } from '../shared-styles';

import { BookmakerCellContainerSmallIcon, bookmakerImgSmallIcon, ImgWrapperSmallIcons } from './style';

export const BookmakerCellSmallIcons = ({
  bookieCode,
  show = true,
}: {
  bookieCode: string;
  show?: boolean;
}): JSX.Element | null => {
  const { oddsShown } = useOddsGridContext();
  const repub = useSelector(state => state.repub);
  const { bookmaker, bookmakerData } = useBookmakerData(bookieCode);
  const isNonClickable = oddsShown === 'OC_NON_CLICKABLE';
  const quickBet = false;

  const { name } = bookmaker;
  const { brandColour, logoLarge } = bookmakerData;

  if (!show) return null;
  return (
    <BookmakerClickOut
      bookmakerCode={bookieCode}
      isNonClickable={isNonClickable}
      repub={repub}
      show={show}
      title={name}
    >
      <BookmakerCellContainerSmallIcon backgroundColour={brandColour}>
        <ImgWrapperSmallIcons>
          <Picture
            altText={name}
            className={bookmakerImgSmallIcon}
            style={{ height: '100%', width: '100%' }}
            svgSrc={logoLarge}
          />
        </ImgWrapperSmallIcons>
        {quickBet && (
          <span className={quickBetIcon}>
            <QuickBetsIcon />
          </span>
        )}
      </BookmakerCellContainerSmallIcon>
    </BookmakerClickOut>
  );
};
